import React from "react";
import ReactDOM from "react-dom";
import ConfirmBagRemovalModal from "../../../app/components/modals/ConfirmBagRemovalModal";

export default function renderConfirmBagRemovalModal({
  target = "modal-container",
  ...rest
}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(<ConfirmBagRemovalModal {...rest} />, domTarget);
  }
}
